import t from"antd/lib/steps";export{default as Steps}from"antd/lib/steps";var e=t.Step;export{e as Step};
